export default "__VITE_ASSET__CLbsjwnf__"